module.exports = __webpack_public_path__ + "img/CS4-3.c1612cd8.png";